import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";

const Home = lazy(() => import("@/pages/home/page"));
const Products = lazy(() => import("@/pages/products/page"));
const ProductDetail = lazy(() => import("@/pages/product/page"));
const Cart = lazy(() => import("@/pages/cart/page"));
const Checkout = lazy(() => import("@/pages/checkout/page"));
const Quality = lazy(() => import("@/pages/quality/page"));
const About = lazy(() => import("@/pages/about/page"));
const Impressum = lazy(() => import("@/pages/impressum/page"));
const Datenschutz = lazy(() => import("@/pages/datenschutz/page"));
const Agb = lazy(() => import("@/pages/agb/page"));
const Widerruf = lazy(() => import("@/pages/widerruf/page"));
const Cookies = lazy(() => import("@/pages/cookies/page"));
const NotFound = lazy(() => import("@/pages/NotFound"));

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/produkte",
        element: <Products />,
      },
      {
        path: "/produkte/:kategorie",
        element: <Products />,
      },
      {
        path: "/produkt/:slug",
        element: <ProductDetail />,
      },
      {
        path: "/warenkorb",
        element: <Cart />,
      },
      {
        path: "/kasse",
        element: <Checkout />,
      },
      {
        path: "/qualitaet",
        element: <Quality />,
      },
      {
        path: "/ueber-uns",
        element: <About />,
      },
      {
        path: "/impressum",
        element: <Impressum />,
      },
      {
        path: "/datenschutz",
        element: <Datenschutz />,
      },
      {
        path: "/agb",
        element: <Agb />,
      },
      {
        path: "/widerruf",
        element: <Widerruf />,
      },
      {
        path: "/cookies",
        element: <Cookies />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;